import { render, staticRenderFns } from "./AffiliatesView.vue?vue&type=template&id=aa3c5fa8&"
import script from "./AffiliatesView.vue?vue&type=script&lang=js&"
export * from "./AffiliatesView.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesView.vue?vue&type=style&index=0&id=aa3c5fa8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports